// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getInvoicePaymentPaymetricConfig } from "@eisinc/App/Services/SettingsService";
import {
    ApiHandlerNoParameter,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { PaymetricConfig } from "@insite/client-framework/Services/SettingsService";

type HandlerType = ApiHandlerNoParameter<PaymetricConfig>;

export const GetPaymetricConfig: HandlerType = async props => {
    props.apiResult = await getInvoicePaymentPaymetricConfig();
};

export const DispatchCompleteLoadPaymetricConfig: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteLoadPaymetricConfig",
        paymetricConfig: props.apiResult,
    });
};

export const chain = [GetPaymetricConfig, DispatchCompleteLoadPaymetricConfig];

const loadInvoicePaymentPaymetricConfig = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadInvoicePaymentPaymetricConfig");
export default loadInvoicePaymentPaymetricConfig;
